import {
	operatorControlConstants
}from "./constants"
import actions from "../../actions"

const initialState = {
	//getList
	isSending : false,
	list      : null,

	//find
	findResult      : null,
	findSending     : false,
	changed         : null,
	error           : null,
	restoreSending  : false,
	createIsFailure : null
}

export default function (state = initialState, action){
	switch (action.type){
		case operatorControlConstants.GetList.REQUEST:
		case operatorControlConstants.Create.REQUEST:
		case operatorControlConstants.Update.REQUEST:
		case operatorControlConstants.Delete.REQUEST:
		case operatorControlConstants.Restore.REQUEST:
		case operatorControlConstants.GetPaged.REQUEST:
			return {
				...state,
				isSending       : true,
				changed         : null,
				createIsFailure : null
			}
		case operatorControlConstants.Find.REQUEST:
			return {
				...state,
				findSending: true
			}
		case operatorControlConstants.GetList.FAILURE:
		case operatorControlConstants.Update.FAILURE:
		case operatorControlConstants.Create.FAILURE:
		case operatorControlConstants.Delete.FAILURE:
		case operatorControlConstants.Restore.FAILURE:
		case operatorControlConstants.GetPaged.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case operatorControlConstants.Find.FAILURE:
			return {
				error       : action.payload,
				findSending : false
			}
		case operatorControlConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}

		case operatorControlConstants.Create.SUCCESS:
			return {
				...state,
				isSending       : false,
				changed         : action.payload.result ? actions.create : null,
				createIsFailure : action.payload.result === false ? 'Проверьте введёные данные!' : null
			}

		case operatorControlConstants.Update.SUCCESS:

			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}

		case operatorControlConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}

		case operatorControlConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}

		case operatorControlConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				listPaged : action.payload.result
			}

		case operatorControlConstants.Find.SUCCESS:
			return {
				...state,
				findSending : false,
				findResult  : action.payload.result
			}

		case operatorControlConstants.CLEAR:
			return {
				...state,
				isSending       : false,
				list            : null,
				findResult      : null,
				findSending     : false,
				changed         : null,
				error           : null,
				restoreSending  : false,
				createIsFailure : null,
				listPaged       : null
			}
		default:
			return state
	}
}
